interface props {
    options: string[];
    locationFirst: string;
    param: string;
    chosenState: { [key: string]: any }

}

function Select({ options, locationFirst, param, chosenState }: props) {
    let disable:boolean = options.length === 2;
    disable = disable && (options[0] === locationFirst);
    return (
        <select onChange={e => {
            let newChosens = { ...chosenState.chosens };
            newChosens[param] = e.target.value;
            chosenState.setChosens(newChosens);
            console.log("CHOSEN STATE", chosenState);
        }}>
            {options.map((op, i) => {
                return <option key={op} hidden={i === 0} selected={i === 0} disabled={disable && (i === 1)}>{op}</option>
            })}
        </select>
    );
}

export default Select;